import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterOutlet, CommonModule, HttpClientModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit {
  LoggedIn = JSON.parse(localStorage.getItem('login') || 'false');
  isMobileMenuOpen: boolean = false;
  isDropdownOpen = false;
  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }
  constructor(private router: Router) {}

  ngOnInit() {}

  logout() {
    localStorage.clear();
    localStorage.setItem('login', JSON.stringify(false));
    window.location.reload();
    this.router.navigateByUrl('login');
  }
  navigateToProfile() {
    this.router.navigateByUrl('profile');
  }
  throwError() {
    try {
      throw new Error('Test Error from Angular');
    } catch (error) {
      console.error(error);
    }
  }
  navigateToVendorSignUp() {
    this.router.navigateByUrl('vendor-sign-up');
  }
  navigateToVendorLogin() {
    this.router.navigateByUrl('login');
  }
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown() {
    this.isDropdownOpen = false;
  }
}
